// src/modules/app-views/dataSearch/pages/Document/actions/dropdownMenu.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
const dataSearchDocumentDropdownMenu = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default dataSearchDocumentDropdownMenu;

// *******************************************************************************
// HELPERS
// *******************************************************************************
